"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.native.help': '原生知识对普通用户隐藏，但可供AI助手使用',
};
